import invoice from '@/locales/es/invoice/invoice.locales';

export default {
    ...invoice,
};
